import React from 'react';
import ErrorBoundary from 'common/components/ErrorBoundary';

import CopyMagic from './CopyMagic';
import { CopyMagicPropsInterface } from './CopyMagic.types';
import { GENERATOR_NAMES } from './constants';
import { withCopyMagicProvider } from './contexts';
import copyMagicLog from './shared/copyMagicLog';
import { withCopyMagicEventsListener } from './CopyMagicEvents';

class CopyMagicContainer extends React.Component<CopyMagicPropsInterface> {
  static GENERATORS = GENERATOR_NAMES;

  render() {
    const WrappedComponent = withCopyMagicProvider(
      withCopyMagicEventsListener(() => <CopyMagic />),
    );
    return (
      <ErrorBoundary fallbackRender={fallbackRender(this.props)}>
        <WrappedComponent {...this.props} />
      </ErrorBoundary>
    );
  }
}

const fallbackRender =
  ({ trigger }: CopyMagicPropsInterface) =>
  ({ error }: { error: any }) => {
    copyMagicLog(error, { level: 'error' });
    return React.cloneElement(trigger, { disabled: true });
  };

export default CopyMagicContainer;
